export const ROOT_SLUG = "enboq";
export const DEFAULT_LOCALE = "en";
